module.exports = __webpack_public_path__ + "img/icon-healthcare.9c0020fb.svg";